import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { IAnswer } from './answer';
import { Error } from './error';

export class Compton {
  public readonly axios: AxiosInstance;
  private _errors = new Error();

  public constructor() {
    this.axios = axios.create({
      baseURL: '/wp-json/mb-compton/v1',
    });
  }

  public async answer(request: { url: string; answers: IAnswer[] }) {
    try {
      await this.axios.post('/answer', request);

      return true;
    } catch (e: unknown) {
      if (e instanceof AxiosError) {
        const response = e.response as AxiosResponse<Error>;
        this._errors = new Error(response.data);
      }

      return false;
    }
  }
}
